module.exports = __webpack_public_path__ + "images/category_lp/watch/reason3@2x_6f4c939fa9ba568e0a7a248b24bcb94e.png";